import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ACTION_DELETE_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ACTION_DELETE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const actionDelete = (actionId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ACTION_DELETE_REQUEST });

    axios.delete(`/actions/${actionId}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
